(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/loader/views/loader.js') >= 0) return;  svs.modules.push('/components/components/loader/views/loader.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.loader=_cmps.loader||{};
_cmps.loader.templates=_cmps.loader.templates||{};
svs.components.loader.templates.loader = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"js-loader-container loader-container hide\">\n  <div class=\"js-loader-placeholder loader-placeholder\"></div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-components-loader-loader'] = svs.components.loader.templates.loader;
})(svs, Handlebars);

 })(window);